export default {
  getCarousels: (state) => state.carousels,
  getSwimLaneByCarouselType: (state) => (carouselType) =>
    state.carouselTypeSwimLane[carouselType] || '',
  getCommonBreakpoints: (state) => state.breakpoints.common,
  getBreakpoints: (state) => (type) => state.breakpoints[type] || {},
};
